module.exports = __webpack_public_path__ + "static/img/pDR1.f08e0ac3.png";